import { render } from "./CostosPersonalPorcent.vue?vue&type=template&id=1c5e08f4&scoped=true"
import script from "./CostosPersonalPorcent.vue?vue&type=script&lang=js"
export * from "./CostosPersonalPorcent.vue?vue&type=script&lang=js"

import "./CostosPersonalPorcent.vue?vue&type=style&index=0&id=1c5e08f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c5e08f4"

export default script